// extracted by mini-css-extract-plugin
export default {"avatar":"Photo_avatar__iCoKn","particles":"Photo_particles__0t41P"};